package dk.smark.chat.network

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class FriendRequest(
    val id: Int,
    @SerialName("from_user_id") val fromUserId: Int,
    @SerialName("to_email") val toEmail: String,
    val status: String,
    @SerialName("created_at") val createdAt: String? = null
)

@Serializable
data class SendFriendRequestBody(val toEmail: String)

@Serializable
data class InviteContactRequest(val email: String, val inviterName: String)
